import { supabase } from "../../supabaseClient";

export const saveInvoice = async (id = undefined, item) => {
  if (id) {
    return await supabase
      .from("Invoice")
      .update({ ...item })
      .match({ id });
  } else {
    return await supabase.from("Invoice").insert([{ ...item }]);
  }
};

export const removeInvoice = async (item) => {
  return await supabase
    .from("Invoice")
    .update({ ...item, deleted_at: new Date() })
    .match({ id: item.id });
};

export const editInvoice = async (id_user = undefined) => {
  return await supabase
    .from("Invoice")
    .update({ status: 1 })
    .is("status", null)
    .is("deleted_at", null)
    .eq("id_user", id_user);
};
